export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">
                春色影视
              </span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed max-w-md">
              春色影视汇聚电影大全，高清免费在线观看，免费不收费，最新热门电影资源库，不缓冲流畅播放，涵盖电视剧全集，满足全类型观影需求。让好电影触手可及。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-200 text-base mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '专题推荐', href: '#carousel' },
                { label: '关于我们', href: '#about' },
                { label: '精选推荐', href: '#cards' },
                { label: '热播榜单', href: '#ranking' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer no-underline"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-200 text-base mb-4">合作伙伴</h4>
            <p className="text-background-500 text-sm">优质影视资源合作方持续接入中，敬请期待。</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; 2026 春色影视 - 电影大全高清免费在线观看。本站所有资源仅供学习交流，请勿用于商业用途。
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" className="text-background-500 hover:text-background-200 text-xs transition-colors cursor-pointer no-underline">回到顶部</a>
            <a href="#contact" className="text-background-500 hover:text-background-200 text-xs transition-colors cursor-pointer no-underline">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}